import { IPmListFilterRaw } from 'PreventionPackage/MainModule/interfaces/IPmListFilterRaw';
import { SYSTEM_DATE_FORMAT_FNS } from 'CorePackage/MainModule/constants/dateFormats';
import { formatDate } from 'CorePackage/MainModule/common/formatDate';

import { IPmListFilter } from '../interfaces/IPmListFilter';

export function mapPmFilterToRaw(data: IPmListFilter): IPmListFilterRaw {
  const { supervisionType } = data;

  return {
    name: data.name,
    years: data?.years?.map(yearSelectOption => Number(yearSelectOption.value)) || [],
    domainIds: data?.domains?.map(domain => domain?.id) || [],
    includeDomainChild: data?.includeDomainChild,
    kinds: data?.kinds?.map(kindSelectOption => kindSelectOption.label) || [],
    controllingOrganizationIds:
      data?.controllingOrganizations?.map(
        controllingOrganization => controllingOrganization?.idStr || controllingOrganization?.id,
      ) || [],
    controllingOrganizationErvkUuids:
      data?.controllingOrganizations
        ?.map(controllingOrganization => {
          if (
            controllingOrganization?.value &&
            typeof controllingOrganization.value === 'object' &&
            'dictVersionId' in controllingOrganization.value
          ) {
            return (controllingOrganization.value as { dictVersionId: string }).dictVersionId;
          }

          return undefined;
        })
        .filter((id): id is string => id !== undefined) || [],
    includeChildKno: data?.includeChildKno,
    ignoreKno: data?.ignoreKno,

    supervisionTypeId:
      supervisionType && 'code' in supervisionType
        ? supervisionType.code
        : (typeof supervisionType?.value === 'number' && supervisionType?.value) || '',
    startDateBetween:
      data?.startDateBetweenStart && data?.startDateBetweenEnd
        ? [
            formatDate({ date: data.startDateBetweenStart, dateFormat: SYSTEM_DATE_FORMAT_FNS }),
            formatDate({ date: data.startDateBetweenEnd, dateFormat: SYSTEM_DATE_FORMAT_FNS }),
          ]
        : undefined,
    hasObjectionWarning: data?.hasObjectionWarning?.value,
    reasonIds: data?.reasons?.map(genericReasonSelectOption => genericReasonSelectOption.id) || [],
    subjectTypeIds: data?.subjectTypes?.map(subjectTypeSelectOption => subjectTypeSelectOption.code) || [],
    subjectOrgName: data?.subjectOrgName,
    subjectOgrn: data?.subjectOgrn,
    subjectInn: data?.subjectInn,
    subjectKpp: data?.subjectKpp,
    subjectOkveds: data?.subjectOkveds,
    subjectSnils: data?.subjectSnils,
    subjectCountryIds: data?.subjectCountries?.map(countrySelectOption => countrySelectOption.id) || [],
    objectAddress: data?.objectAddress,
    objectTypeIds: data?.objectTypes?.map(objectTypeSelectOption => objectTypeSelectOption.id) || [],
    objectKindIds: data?.objectKinds?.map(objectKindSelectOption => objectKindSelectOption.value.dictVersionId) || [],
    objectSubKindIds:
      data?.objectSubKinds?.map(objectSubKindSelectOption => objectSubKindSelectOption.value.dictVersionId) || [],
    objectRiskCategoryId: data?.objectRiskCategory?.id,
    objectDangerClassId: data?.objectDangerClass?.id,
    isHasCollaboratingOrganization: data?.isHasCollaboratingOrganization?.value,
    inspectorFullName: data?.inspectorFullName,
    signed: data?.signed?.value,
    statusIds: data?.statuses?.map(statusSelectOption => statusSelectOption.id) || [],
    pubStatuses: data?.pubStatuses?.map(pubStatusSelectOption => pubStatusSelectOption.value) || [],
    erpId: data?.erpId,
    deletedInclude: data?.deletedInclude?.value,
    deletedOnly: data?.deletedOnly?.value,
    isTest: data?.isTest?.value,
  };
}
